













































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter,Action} from "vuex-class";
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import { Gender, Grade, AxiosPromiseError, AxiosPromiseData } from "@/common/interface"
import { GRADE, GENDER } from '@/common/constants';
import Validate from '@/mixins/validate';
import VaidateCondition from '@/mixins/validateCondition';
import fetch from '@/common/api/fetch';
import ActivitySection from "@/components/common/index/ActivitySection.vue";
import store from '@/store';
import getDistance from '@/common/utils/getDistance';

interface SmsCode {
  sig: string,
  token: string,
  csessionid: string,
}
const validateCondition = VaidateCondition();
@Component({
  components: {
    "activity-section": ActivitySection
  }
})
export default class GachaModal extends Vue {
  @Prop({ default: false, type: Boolean }) visible!: boolean;
  @Prop() getterUid!: string;
  @Prop() signupItemConfig!: {[index: string]: string };
  @Prop() documentTitle!: string;
  @Prop() instId!: string;
  @Prop() madeByOrg?: boolean;
  @Prop() leadersInstId?: string;
  @Getter("gachaTypeParameter") gachaTypeParameter!: any;
  gradeArr: Grade[] = GRADE;
  genderArr: Gender[] = GENDER;

  name: string = "";
  phone: string = "";
  phoneCode: string = "";
  age: number = 0;
  ageStr: string = "";
  grade: string = "";
  gradeStr: string = "";
  school: string = "";
  birthday: string = "";
  birthdayStr: string = "";
  gender: string = ""; // 性别
  genderStr: string = "";
  intention: string = ""; // 课程意向
  customizeList: any = [];

  timer: any = null;
  remainTime: number = 0;
  selectInstId?: string = "";

  @Watch("visible")
  removeEventListener() {
    if (!this.visible) {
      window.removeEventListener('message', this.messageEvent);
    }
  }

  mounted() {
    setTimeout(() => {
      let customizeList: any = [];
      (this.signupItemConfig.customizeList as any || []).forEach((item: any) => {
        !this.getterUid && (delete item.value);
        item.isOpen && customizeList.push(item);
      });
      this.customizeList = customizeList;
      
      const instVOList = store.getters.instVOList;
      if (instVOList && instVOList.length) {
        this.selectInstId = instVOList[0].instId;
        if (this.leadersInstId) {
          this.selectInstId = this.leadersInstId || this.selectInstId;
        } else if (window.__wxjs_environment === 'miniprogram' && this.madeByOrg) {
            window.wx.getLocation({
            success: (value: any) => {
              let min = Infinity;
              let selectInstId = this.selectInstId;
              instVOList.map((item: any) => {
                const distance = getDistance(item, value)
                min = Math.min(distance, min);
                (item.longitude || item.latitude) && min === distance && (selectInstId = item.instId);
              })
              this.selectInstId = selectInstId;
            }
          });
        }
      }
    }, 1000)
    window._xm_slide.init();
    window.addEventListener("message", this.messageEvent);
  }
  changeCustomizeList(e: any, index: number) {
    this.customizeList[index].value = e.target.value;
  }
  messageEvent(e: any) {
    window._xm_slide.remove();
    e.data.token && this.handSendCodeSucc(e.data);
  }
  handleCloseModal() {
    (this as any).cancel();
  }
  handleJoin() {
    if (getUrlParam('hot')) {
      Vue.$toast.info('该活动仅供预览');
      return;
    }
    // 没有报名
    if (!this.getterUid) {
      if (this.hasError()) {
        Vue.$toast.error(this.hasError());
        return;
      }
  
      const jsonObj: any = {};
      for (let key in this.signupItemConfig) {
        if (this.signupItemConfig[key]) {
          jsonObj[key] = (this as any)[key];
        }
      }
      const jsonStr = JSON.stringify(jsonObj);

      (this as any).ok(this.name, this.phone, this.phoneCode,  jsonStr)

      try {
        if (getActivityType() === "lessonType") {
          if (window.__wxjs_environment === "miniprogram") {
            window.TDAPP.onEvent("点击【提交名单】-【微传单】", "小程序", {
              来源: "小程序",
              活动名称: this.documentTitle
            });
          } else {
            window.TDAPP.onEvent("点击【提交名单】-【微传单】", "H5", {
              来源: "H5",
              活动名称: this.documentTitle
            });
          }
        }
      } catch (error) {
         Vue.$toast.error(error);
      }
    } else { // 已经报名了
      (this as any).cancel();
    }
  }

  hasError() {
    const validate = new Validate(validateCondition);
    validate.add(this.name, [{
      condition: 'isNonEmpty',
      errMsg: '请输入学员姓名'
    }, {
      condition: 'haSpecialChar',
      errMsg: '姓名中不能包含特殊字符'
    }]);
    validate.add(this.name.length, [{
      condition: 'isLessThen',
      limit: 15,
      errMsg: '请输入15个字以内的姓名',
    }]);

    validate.add(this.phone, [{
      condition: 'isNonEmpty',
      errMsg: '请输入手机号'
    }, {
      condition: 'isPhoneRight',
      errMsg: '请输入正确的手机号'
    }]);
    
    const { age, grade, school, birthday, gender, intention, customizeList } = this.signupItemConfig;
    age && validate.add(this.age, [
    {
      condition: "isIntervalRight",
      min: 1,
      max: 118,
      errMsg: '请输入1-118之间的年龄'
    }, 
    {
      condition: 'isNonEmpty',
      errMsg: '请输入年龄'
    }, {
      condition: 'isInteger',
      errMsg: '年龄必须为正整数'
    }]);
    grade && validate.add(this.grade, [{
      condition: 'isNonEmpty',
      errMsg: '请选择年级'
    }]);
    school && validate.add(this.school, [{
      condition: 'isNonEmpty',
      errMsg: '请输入在读学校'
    }]);
    birthday && validate.add(this.birthday, [{
      condition: 'isNonEmpty',
      errMsg: '请选择出生年月'
    }]);
    gender && validate.add(this.gender, [{
      condition: 'isNonEmpty',
      errMsg: '请选择性别'
    }]);
    intention && validate.add(this.intention, [{
      condition: 'isNonEmpty',
      errMsg: '请输入意向课程'
    }]);
    customizeList && validate.add(this.customizeList, [{
      condition: 'isCustomizeEmpty',
      errMsg: '',
    }]);
    
    return validate.result();
  }

  _setTimer() {
    this.remainTime--;
    if (this.remainTime < 1) {
      this.timer = null;
      return;
    }
    this.timer = setTimeout(() => {
      this._setTimer();
    }, 1000);
  }

  //  获取验证码
  handleGetPhoneCode() {
    // 判断手机号是否符合格式
    const validate = new Validate(validateCondition);
    validate.add(this.phone, [{
      condition: 'isNonEmpty',
      errMsg: '请输入手机号'
    }, {
      condition: 'isPhoneRight',
      errMsg: '请输入正确的手机号'
    }]);
    if (validate.result()) {
      Vue.$toast.error(this.hasError());
      return;
    }
    window._xm_slide.open();
  }

  handSendCodeSucc(checkData: SmsCode) {
    // 发送请求，如果请求成功，改变状态
    const { sig, csessionid, token, } = checkData;
    const param = {
      sig,
      token,
      sessionId: csessionid,
      scene: "nc_login_h5",
      sideType: 0,
      serverType: "SHOW_VERIFY",
      activityId: getUrlParam('broadcastId'),
      instId: this.instId,
      phone: this.phone
    };
    fetch.Sales('anon/show/customer/sendMachineCheckJoinAuthCode', param).then((res: AxiosPromiseData) => {
      const { success } = res;
      if (success) {
        Vue.$toast.success("短信发送成功，请注意查收！");
        this.remainTime = 60;
        this._setTimer();
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.remainTime = 0;
      }
    });
  }
  // 年级选择器
  handleGradePicker() {
    window.weui.picker(this.gradeArr, {
      onConfirm: (result: any) => {
        this.gradeStr = result[0].label;
        this.grade = result[0].value;
      }
    });
  }
  // 出生年月选择器
  handleDatePicker() {
    window.weui.datePicker({
      start: 1990,
      end: new Date().getFullYear(),
      // onChange: function() {
      //   document
      //     .getElementsByClassName("weui-picker__group")[2]
      //     .setAttribute("style", "display:none"); // 去除日期列
      // },
      onConfirm: (result: any) => {
        const year: number = result[0].value;
        const month: string =
          result[1].value >= 10 ? "" + result[1].value : "0" + result[1].value;
        const day: string = 
          result[2].value >= 10 ? "" + result[2].value : "0" + result[2].value;
        this.birthdayStr = `${year}-${month}-${day}`;
        this.birthday = `${year}-${month}-${day}`;
      }
    });
  }
  // 性别选择器
  handleGenderPicker() {
    window.weui.picker(this.genderArr, {
      onConfirm: (result: any) => {
        this.genderStr = result[0].label;
        this.gender = result[0].value;
      }
    });
  }
  handleAge() {
    this.age = Number(this.ageStr);
  }

  handleFormatGrade(grade: Number) {
    this.gradeArr.forEach((v: Grade) => {
      if (v.value === grade) {
        this.gradeStr = v.label;
      }
    });
    return this.gradeStr
  }
  handleFormatGender(gender: Number) {
    this.genderArr.forEach((v: Gender) => {
      if (v.value === gender) {
        this.genderStr = v.label;
      }
    });
    return this.genderStr
  }
}
